(function () {

    if (!document.querySelector('.section-video__slider')) {
        return;
    }

    let slider = tns({
        container: '.section-video__slider',
        responsive: {
            "600": {
                items: 1,
                fixedWidth: 357,
            },
            "601": {
                fixedWidth: 406,
                autoWidth: true,
            },
            "1299": {
                items: 4,
                fixedWidth: 406,
            },
            "1500": {
                items: 4,
                fixedWidth: 406,
            },
        },
        center: true,
        controlsPosition: 'bottom',
        autoplayButtonOutput: false,
        nav: false,
        slideBy: 1,
        controlsContainer: "#customize-controls",
        gutter: 40,
        preventActionWhenRunning: true,
        onInit: zoomMiddleSlide,
        autoplay: true,
        lazyload: true,
    });

    slider.events.on('transitionEnd', () => {
        const activeSlides = document.querySelectorAll('.tns-slide-active');
        let centerElement = 0;
        if (activeSlides) {
            centerElement = Math.floor(activeSlides.length / 2);
        }

        if (activeSlides[centerElement]) {
            activeSlides[centerElement].classList.add('section-video__slider-item--zoom');
        } else {
            slider.destroy();
            slider = slider.rebuild()
        }
    })

    slider.events.on('transitionStart', () => {
        zoomMiddleSlide();
    });


    function zoomMiddleSlide() {
        const activeSlides = document.querySelectorAll('.tns-slide-active');
        activeSlides.forEach((element) => {
            element.classList.remove('section-video__slider-item--zoom');
        })
    }
})(tns)


